import { Fragment, useState } from "react";
import { boolAndReducer } from "../common/functions";
import { Link, useLoaderData } from "react-router-dom";
import UserInfo from "../common/userInfo";
import Footer from "../common/frame/footer";
import { Post } from "./types";
export default function PostList(){
    const posts = useLoaderData() as Post[];
    const [filterWords, setFilterWords] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //--------------------------------------------------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredPosts = posts.filter(u => (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true)) 
    );
    const currentPagePosts = filteredPosts.slice(indexOfFirstItem, indexOfLastItem);
    return (
        <div className = "cssContent pb8rem">
            <nav className = "mt-3 mb-4">
                 <span className = "me-3">
                    <label
                        children = "Search:"
                        htmlFor = "search"
                        className = "me-2"
                    />
                    <input
                        id = "search"
                        className = "form-control inline w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                        }}
                    />
                </span>
                <Link children = "Add" to = "Add" className = "btn btn-primary float-end"/>
            </nav>
            {!filteredPosts.length?
            <div className = "cssLoading">Empty</div>:
            <div className = "overflow-visible">
                <table className = "table">
                    <thead>
                        <tr className = "stickyHeader">
                            <th className = "text-left">User Name</th>                    
                            <th className = "text-left">Subject</th>
                            <th className = "text-left">Created At</th>
                            <th className = "text-left">Updated At</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {currentPagePosts.map((post, postIndex) =>
                            <Fragment key = {postIndex}>
                            <tr>
                                <td>
                                    <UserInfo
                                        name = {post.creatorName}
                                        id = {post.creatorId}
                                    />
                                </td>
                                <td>
                                    <span className = "fw-bold h5">{post.subject}</span>
                                    {post.updatedAt?<span className = "ms-3 badge badge-secondary">edited</span>:null}
                                </td>
                                <td className = "text-secondary">
                                    {post.createdAt}
                                </td>
                                <td className = "text-secondary">
                                    {post.updatedAt}
                                </td>
                                <td>
                                    <Link children = "Detail" to = {String(post.id)} className = "btn btn-primary"/>
                                </td>
                            </tr>
                        </Fragment>)}
                    </tbody>
                </table>
            </div>}
            {filteredPosts.length?
            <Footer
                length = {filteredPosts.length}
                currentPage = {currentPage}
                setCurrentPage = {setCurrentPage}
                itemsPerPage = {itemsPerPage}
                setItemsPerPage = {setItemsPerPage}
            />
            :null}
        </div>
    );
}
